import * as React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import "./DanfePdfPage.css";
import DanfeFirstPage from "../../components/danfepdf/DanfeFirstPage";
import DanfeNextPage from "../../components/danfepdf/DanfeNextPage";
import { useTranslation } from "react-i18next";
import { fetchFileXml } from "../../services/fileXmlService";
import { parseNfeXml } from "../../utilities/Utilities";
import { mapParsedNfeToDanfeData } from "../../utilities/mapParsedNfeToDanfeData";

const DanfePrintPage = () => {
  const { t } = useTranslation();
  const { accessKey } = useParams();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    async function load() {
      try {
        const result = await fetchFileXml(accessKey);
        if (!result?.xml) return;
        const parsed = parseNfeXml(result.xml, t);
        setData(mapParsedNfeToDanfeData(parsed));
      } catch (err) {
        console.error("Erro ao carregar DANFE:", err);
      } finally {
        setLoading(false);
      }
    }
    if (accessKey) load();
  }, [accessKey, t]);

  if (loading) return <Box sx={{ p: 2 }}>Carregando DANFE...</Box>;
  if (!data)   return <Box sx={{ p: 2 }}>Dados da DANFE não encontrados.</Box>;

  return (
    <Box className="danfe-page" sx={{ backgroundColor: "#fff" }}>
      <DanfeFirstPage data={data} folha={`1/${data.itemsPages.length}`} />
      {data.itemsPages.slice(1).map((items, index) => (
        <DanfeNextPage
          key={index}
          data={data}
          folha={`${index + 2}/${data.itemsPages.length}`}
          items={items}
        />
      ))}
    </Box>
  );
};

export default DanfePrintPage;
